import { Button, EmptyState } from '@robotensor/ui'
import { Link, useLocation } from '@tanstack/react-router'

export function NotFound() {
  const location = useLocation()
  return (
    <div className="rt-page">
      <EmptyState
        label="404 · no such page"
        title="This address doesn’t lead anywhere"
        meta={<span>{location.pathname}</span>}
        actions={
          <>
            <Button asChild variant="primary">
              <Link to="/">Go home</Link>
            </Button>
            <span className="rt-muted">
              or press <kbd className="rt-kbd">⌘K</kbd> to search
            </span>
          </>
        }
      >
        If someone shared this link, the item may have moved or you may not have access to it.
      </EmptyState>
    </div>
  )
}
